import { AnyAction } from 'redux';
import { IObservationServiceObj } from '../../../shared/apiServices/IApiInterfaces';
import * as ActionType from '../../actions/ActionTypes';

const initialState: IObservationReducerState = {
    ObservationObject: {} as IObservationServiceObj
};

const observationReducer = (oldState: IObservationReducerState = initialState, action: AnyAction): IObservationReducerState => {

    let newState = { ...oldState }
    switch (action.type) {
        case ActionType.SET_OBSERVATION_OBJECT:
            newState.ObservationObject = action.payload
            break;
    }

    return newState;
}

export default observationReducer;